import clsx from 'clsx';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import PropTypes from 'prop-types';

// Lib
import { calendarViews } from '@/lib/scheduler/calendar/calendar';

// Components
import { SelectComponent } from '@/components/base/Select/SelectComponent/SelectComponent';

const SelectCalendarView = ({
    viewSelected,
    onChange,
    buttonVariant = 'grayNoBorder',
    className
}) => {
    const { t } = useTranslation('scheduler');

    const viewsListOptions = [
        { label: t('calendar.views.day'), value: calendarViews.day },
        { label: t('calendar.views.week'), value: calendarViews.week },
        { label: t('calendar.views.month'), value: calendarViews.month }
    ];

    return (
        <div className={clsx('w-28', className)}>
            <SelectComponent
                selected={viewsListOptions.filter((item) => viewSelected === item.value)[0]}
                setSelected={onChange}
                options={viewsListOptions}
                buttonVariant={buttonVariant}
                panelOptions={{ size: 'xs' }}
            />
        </div>
    );
};

SelectCalendarView.propTypes = {
    viewSelected: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
};

export default SelectCalendarView;
